module.exports = __webpack_public_path__ + "static/media/logo.a454d7d6.png";